<template lang="pug">
div.sidebar-banner.sidebar-banner--tv(v-if="isActive")
  div.sidebar-banner__heading
    a.sidebar-banner__heading-link(href='/tv')
      h4.sidebar-banner__heading-text
        img.sidebar-banner__heading-icon-img(src='/src/images/prtimes-jp/html/logo_prtimes-tv.svg', alt="PR TIMES TV")
  div.sidebar-banner__content
    a.sidebar-banner__link(target='_blank'. rel='nofollow', :href="`/tv/detail/${value.id}`")
      div.sidebar-banner__content-image
        span.sidebar-banner__content-image-img.js-lazyload(:data-bg="`/tv/${value.thumbnail}`", :title="value.title")
        div.sidebar-banner__content-image-control
          img.sidebar-banner__content-image-control-icon(src="/src/images/prtimes-jp/html/icon_sidebar-tv-play.svg", alt="play")
          span.sidebar-banner__content-image-control-time {{value.duration | formattedVideoTime}}
      h5.sidebar-banner__content-title {{value.title}}
      time.sidebar-banner__content-time {{value.created_at | formattedCreatedAt}}
    div.sidebar-banner__content-more
      a.sidebar-banner__content-more-button(href="/tv") もっと見る
</template>

<script>
import { tvCreatedAtStr, toHms } from './../../utilities/modifyTime';

export default {
  name: 'AddBannerElement',
  props: {
    valueProps: {
      type: Object,
      default: () => {}
    },
    isActiveProps: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      value: {},
      isActive: false
    };
  },
  watch: {
    valueProps (newValue, oldValue) {
      this.value = newValue;
    },
    isActiveProps (newValue, oldValue) {
      this.isActive = newValue;
    }
  },
  filters: {
    formattedVideoTime (duration) {
      return toHms(Number(duration));
    },
    formattedCreatedAt (createdAt) {
      return tvCreatedAtStr(createdAt);
    }
  }
};
</script>
